// extracted by css-extract-rspack-plugin
module.exports =  {"checkbox":"b12d770813","petsshop":"e0ed6d98f1"};